import { Button, Modal, Space, InputNumber } from "antd";
import React, { useState } from "react";
import { EditFilled } from "@ant-design/icons";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase/config";
import { Notification } from "../../Notification";

const initialState = null;

export const RastraPopup = (props) => {
   const [isModalOpen, setIsModalOpen] = useState(initialState);
   const [grams, setGrams] = useState(initialState);
   const [lineatura, setLineatura] = useState(initialState);

   const showModal = async () => {
      setIsModalOpen(true);
      setGrams(props.grams);
      setLineatura(props.lineatura);
   };

   const handleCancel = () => {
      setIsModalOpen(false);
      setGrams(initialState);
      setLineatura(initialState);
   };

   const updateData = async (e) => {
      e.preventDefault();
      const ref = doc(db, "rastra", props.id);
      await updateDoc(ref, {
         grams: grams,
         lineatura: lineatura,
         id: props.id,
      })
         .then(() => {
            setIsModalOpen(true);
            setGrams(initialState);
            setLineatura(initialState);
            Notification("success", "Updated!", "Your data has been updated");
         })
         .then(() => {
            setIsModalOpen(false);
         })
         .catch((err) => {
            Notification("error", "Login Error", err.message);
         });
   };
   return (
      <>
         <Button size="small" type="primary" onClick={showModal}>
            <EditFilled />
         </Button>
         <Modal width={700} title="Lineatura" open={isModalOpen} onOk={updateData} onCancel={handleCancel}>
            <Space>
               <InputNumber addonBefore="Grams :" value={grams} style={{ width: "100%" }} onChange={(value) => setGrams(value)} />
               <InputNumber addonBefore="Lineatura :" value={lineatura} style={{ width: "100%" }} onChange={(value) => setLineatura(value)} />
            </Space>
         </Modal>
      </>
   );
};
